import { render, staticRenderFns } from "./cardService.vue?vue&type=template&id=3e20fce6&scoped=true&"
import script from "./cardService.vue?vue&type=script&lang=js&"
export * from "./cardService.vue?vue&type=script&lang=js&"
import style0 from "./cardService.vue?vue&type=style&index=0&id=3e20fce6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e20fce6",
  null
  
)

export default component.exports